/**
 * HomePage - Главная страница
 */

import React from "react";
import { GuestLayout } from "../../components/layouts";

const HomePage = () => {
    return (
        <GuestLayout showHeader={true} showFooter={true}>
            <div className="title-container">
                <h1 className="main-title main-title--accent">
                    MEDIEVAL <br /> <span className="main-title">ROLEPLAY</span>
                </h1>
                <p className="desc-title">
                    Уникальный текстовый ролевой проект в сеттинге
                    Средневекового фентези.
                </p>

                <div className="buttons-container buttons-container-center">
                    <button className="button-signUp">
                        <a href="/register">ЗАРЕГИСТРИРОВАТЬСЯ</a>
                    </button>
                    <button className="button-downloadLauncher">
                        <a href="/med_setup.exe" download={true}>
                            СКАЧАТЬ ЛАУНЧЕР
                        </a>
                    </button>
                </div>

                <div className="social-icons-container">
                    <a
                        href="https://vk.com/medievalrpnet"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button className="vk-icon"></button>
                    </a>
                    <a
                        href="https://t.me/medieval_rp"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button className="telegram-icon"></button>
                    </a>
                </div>
            </div>
        </GuestLayout>
    );
};

export default HomePage;
